import { gql } from '@efficiently/client-core-graphql-models';

export const GET_PLANS = gql(`
	query getPlans($projectId: String!) {
		plans(projectId: $projectId) {
			plans {
				...PlanFields
			}
			versions {
				...PlanVersionFields
			}
			items {
				...PlanItemFields
				detectionState {
					planItemId
					run {
						...PlanDetectionRunFields
					}
				}
			}
			requests {
				...PdfRequestFields
			}
		}
	}
`);
